import type { Sheet } from '../../types';
import { normalizeSheetColors } from './normalizeSheetColors';
import type { ReadSheetResult } from './types';
import { stripSheetUiFlags } from './stripUiFlags';

/** API read 用: UI フラグ除去済み Sheet JSON と revision を返す */
export function readSheetForApi(sheet: Sheet): ReadSheetResult {
  const revision = sheet.revision ?? 0;
  const cleaned = stripSheetUiFlags(sheet);
  const normalized = normalizeSheetColors(cleaned);
  return {
    ok: true,
    sheetId: sheet.id,
    revision,
    sheet: { ...normalized, revision },
  };
}
